var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "200",
      "height": "200",
      "viewBox": "0 0 200 200",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M50 40L100 30L150 40V160L100 180L50 160V40Z",
      "fill": "#FFC727"
    }
  }), _c('path', {
    attrs: {
      "d": "M100 180L100 60L150 40L150 160L100 180Z",
      "fill": "#FFB300"
    }
  }), _c('rect', {
    attrs: {
      "x": "65",
      "y": "70",
      "width": "70",
      "height": "4",
      "rx": "1",
      "fill": "#FFFFFF",
      "opacity": "0.8"
    }
  }), _c('rect', {
    attrs: {
      "x": "65",
      "y": "80",
      "width": "50",
      "height": "4",
      "rx": "1",
      "fill": "#FFFFFF",
      "opacity": "0.8"
    }
  }), _c('rect', {
    attrs: {
      "x": "65",
      "y": "90",
      "width": "60",
      "height": "4",
      "rx": "1",
      "fill": "#FFFFFF",
      "opacity": "0.8"
    }
  }), _c('rect', {
    attrs: {
      "x": "65",
      "y": "100",
      "width": "45",
      "height": "4",
      "rx": "1",
      "fill": "#FFFFFF",
      "opacity": "0.8"
    }
  }), _c('rect', {
    attrs: {
      "x": "65",
      "y": "110",
      "width": "65",
      "height": "4",
      "rx": "1",
      "fill": "#FFFFFF",
      "opacity": "0.8"
    }
  }), _c('rect', {
    attrs: {
      "x": "65",
      "y": "120",
      "width": "55",
      "height": "4",
      "rx": "1",
      "fill": "#FFFFFF",
      "opacity": "0.8"
    }
  }), _c('rect', {
    attrs: {
      "x": "65",
      "y": "55",
      "width": "70",
      "height": "8",
      "rx": "2",
      "fill": "#FFFFFF",
      "opacity": "0.9"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }